import { msg } from 'gt-react';
import { showToastOutsideReact } from 'src/services/toastService';

/**
 * Longer than `notify403`'s window: a vetoed write is usually a burst — a
 * button mashed twice, a form fanning out several mutations, a background
 * poller retrying — and one explanation per burst is enough.
 */
const DEDUP_WINDOW_MS = 5_000;
const recentMessages = new Map<string, number>();

const VIEW_ONLY_MESSAGE = 'This is only a view mode';

/**
 * Toast shown whenever a write is refused because a Gently admin is imitating
 * a user. Deduped so button-mashing and background pollers can't stack it.
 */
export function notifyViewOnly(): void {
  const now = Date.now();
  const lastShown = recentMessages.get(VIEW_ONLY_MESSAGE);

  if (lastShown !== undefined && now - lastShown < DEDUP_WINDOW_MS) {
    return;
  }

  showToastOutsideReact({
    title: msg('View-only mode'),
    message: msg('This is only a view mode'),
    color: 'warning',
  });

  recentMessages.set(VIEW_ONLY_MESSAGE, now);
}
